import { GraphQLClient } from 'graphql-request'

import { CompanyTranslator } from 'src/translators'
import { CompanyEntity } from 'src/types'
import { getSdk } from 'src/types/generated-request'

export const useGetPromiseCompany = () => {
  const loadCompany = async (accessToken: string): Promise<CompanyEntity> => {
    const response = await getSdk(
      new GraphQLClient(process.env.GraphQLUrl ?? '', {
        headers: { 'bearer-token': accessToken },
      })
    ).getCompany()
    return CompanyTranslator.toEntity(response.company)
  }

  return {
    loadCompany,
  }
}
